var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailureCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6673 3.25825L11.2423 0.833252L7.00065 5.07492L2.75898 0.833252L0.333984 3.25825L4.57565 7.49992L0.333984 11.7416L2.75898 14.1666L7.00065 9.92492L11.2423 14.1666L13.6673 11.7416L9.42565 7.49992L13.6673 3.25825Z",
    fill: "#E84040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureCrossIcon);
export default __webpack_public_path__ + "static/media/failure-cross-icon.da3089ad8f2a263d0d0cd3743d440bb5.svg";
export { ForwardRef as ReactComponent };